import { UserType } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router';

import { UserList } from '@/components/shared/components/UserList/UserList';
import { ModuleCorePermissionProps } from '@/config/types';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const ChannelUserList = ({ canEdit = false }: ModuleCorePermissionProps) => {
  const { channelId } = useParams();

  if (!channelId) return null;

  return <UserList editModeAllowed={canEdit} userIds={[channelId]} userType={UserType.CHANNEL} />;
};

export const ChannelUserListModule = withPermissionsModule(ChannelUserList);
